import { instance } from "@/lib/axios/instance";

export type CockpitCandidateOrigin = {
  id: string;
  name: string | null;
};

type CandidateOriginsApiResponse = {
  data: CockpitCandidateOrigin[];
  totalRecords: number;
};

export async function fetchCockpitCandidateOrigins(
  clientId: string,
  moduleName: string
): Promise<CockpitCandidateOrigin[]> {
  const { data } = await instance.get<CandidateOriginsApiResponse>(
    `/api/v2/Integrations/cockpit/${moduleName}/candidate-origins`,
    { params: { clientId } }
  );
  return data?.data ?? [];
}
